var URLS = {
  chat: '/api/v1',
  commands: '/commands',
  request: '/request/1',
  UAT: 'https://api.beeline.ru/mwuat',
  auth: '/auth/api/commands',
  gettokenAuthZone: '/login/gettoken'
};
export var endpoints = {
  captcha: {
    create: "".concat(URLS.auth, "/createCaptcha"),
    validate: "".concat(URLS.auth, "/validateCaptcha"),
    refresh: "".concat(URLS.auth, "/refresh")
  },
  chat: {
    history: function history(apiVersion) {
      return "/api/".concat(apiVersion, "/history");
    }
  },
  request: {
    constructor: "".concat(URLS.request, "/constructor")
  },
  tokenAuthZone: {
    gettoken: "".concat(URLS.gettokenAuthZone)
  },
  file: {
    sent: '/file/api/commands/upload',
    download: '/file/api/queries'
  },
  UAT: {
    auth: "".concat(URLS.UAT, "/auth/1/auth")
  }
};
export var endpointContent = function endpointContent(apiVersion) {
  return "/api/".concat(apiVersion, "/content");
};